import { type AxiosResponse } from 'axios';

import { request } from '../../../../services/requestService';

import { FILEX_SERVER } from '../../../../config';

const ENDPOINTS = {
  data: 'api/data',
};

export function getFilexData(id: string): Promise<AxiosResponse<string>> {
  return request({
    url: `${ENDPOINTS.data}/${id}`,
    baseURL: FILEX_SERVER,
  });
}
